export default "skymp5-front/3c0f308103c1160f2633b3ec623c2f66.png";